<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Gratuidades",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros-operacionais/gerar-gratuidades/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Gratuidade", value: "gratuidade", sortable: false },
      { text: "Orgão", value: "descricao", sortable: false },
      { text: "Tipo de Serviço", value: "tipo_servico", sortable: false },
      { text: "P.inicial", value: "periodo_quant_inicial", sortable: false },
      {
        text: "P.inicial",
        value: "tipo_periodovenda_inicial",
        sortable: false,
      },
      { text: "P.final", value: "periodo_quant_final", sortable: false },
      { text: "P.final", value: "tipo_periodovenda_final", sortable: false },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },
  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/gerargratuidades").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(
        `/cadastros-operacionais/gerar-gratuidades/editar/${id}`
      );
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/gerargratuidades/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          location.reload(1);
        });
      }
    },
  },
};
</script>
